import React from 'react';
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useNavigate } from 'react-router-dom';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import { SIDEBAR_PIXEL_WIDTH } from '../constants';
import { UserInterfaceRoute } from '../types';
import { AgeroLogo } from './AgeroLogo';
import { SPACING } from '../styles/theme';

// Styled components for Sidebar - preserving original layout and colors
const StyledRoot = styled('div')(() => ({
  display: 'flex',
}));

const StyledDrawer = styled(Drawer)(() => ({
  width: SIDEBAR_PIXEL_WIDTH,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: SIDEBAR_PIXEL_WIDTH,
  },
}));

const StyledToolbar = styled('div')(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

const StyledLogo = styled('div')(() => ({
  marginTop: SPACING.LOGO_MARGIN_TOP,
  textAlign: 'center',
}));

export interface SideBarProps {
  routes: Array<UserInterfaceRoute>;
}

export const SideBar = ({ routes }: SideBarProps) => {
  const navigate = useNavigate();

  return (
    <StyledRoot>
      <CssBaseline />
      <StyledDrawer variant="permanent" anchor="left">
        <StyledToolbar>
          <StyledLogo>
            <AgeroLogo />
          </StyledLogo>
        </StyledToolbar>
        <Divider />
        <List>
          {routes.map(route => (
            <ListItem button key={route.key} onClick={() => navigate(route.to)}>
              <ListItemIcon>
                {route.icon ? route.icon : <InboxIcon />}
              </ListItemIcon>
              <ListItemText>{route.children}</ListItemText>
            </ListItem>
          ))}
        </List>
      </StyledDrawer>
    </StyledRoot>
  );
};
